import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class QuotationVehicleClaim extends BaseModel {
    @Expose() quotationId = 0;
    @Expose() sendAuthorizationDate: string | null = null;
    @Expose() authorizationDate: string | null = null;
    @Expose() evaluationState = "";
    @Expose() totalAmount = 0;
    @Expose() deductible = 0;
    @Expose() workshopName = "";
    @Expose() extension = false;
    @Expose() subTotalLabourAmount: number | null = null;
    @Expose() totalPartsAmount: number | null = null;
    @Expose() inspectionDate: string | null = null;
}
